<template>
  <div class="w-full max-w-[920px] mx-auto space-y-6">
    <ProgressTimeline
      :total="questions.length"
      :current="currentIndex"
      :answers="answers.map((item) => item.answer_value)"
      :response-mode="responseMode"
      :options="options"
      @jump="jumpTo"
    />

    <QuestionCard
      :index="currentIndex"
      :total="questions.length"
      :question="questions[currentIndex]?.text || ''"
      :answer-value="answers[currentIndex]?.answer_value"
      :response-mode="responseMode"
      :options="options"
      :questionnaire-name="questionnaireName"
      @answer="onAnswer"
    />

    <AnsweredList
      :questions="questions.map((item) => item.text)"
      :answers="answers.map((item) => item.answer_value)"
      :current="currentIndex"
      :response-mode="responseMode"
      :options="options"
      @jump="jumpTo"
    />

    <div class="flex items-center justify-end pt-2">
      <button
        type="button"
        class="px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-gray-200 hover:bg-white/10 transition text-sm"
        @click="$emit('request-submit', { answers, questions })"
        :disabled="!isAllAnswered"
        :class="!isAllAnswered ? 'opacity-40 cursor-not-allowed' : ''"
      >
        Enviar respostas
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, defineEmits, defineProps } from "vue";
import ProgressTimeline from "./ProgressTimeline.vue";
import QuestionCard from "./QuestionCard.vue";
import AnsweredList from "./AnsweredList.vue";

const props = defineProps({
  questions: {
    type: Array,
    default: () => [],
  },
  responseMode: {
    type: String,
    default: "binary",
  },
  options: {
    type: Array,
    default: () => [],
  },
  questionnaireName: {
    type: String,
    default: "Questionário",
  },
});

const emit = defineEmits(["request-submit", "status"]);

const currentIndex = ref(0);
const answers = ref([]);

const questions = computed(() => props.questions || []);
const responseMode = computed(() => props.responseMode || "binary");
const options = computed(() => props.options || []);
const questionnaireName = computed(
  () => props.questionnaireName || "Questionário"
);

const isAllAnswered = computed(() =>
  answers.value.every(
    (item) => item.answer_value !== null && item.answer_value !== undefined
  )
);

watch(
  () => props.questions,
  (val) => {
    currentIndex.value = 0;
    answers.value = (val || []).map((question) => ({
      question_id: question.id,
      answer_value: null,
    }));
  },
  { immediate: true }
);

function onAnswer(value) {
  const idx = currentIndex.value;
  const current = answers.value[idx];

  answers.value.splice(idx, 1, {
    ...current,
    answer_value: value,
  });

  const last = questions.value.length - 1;

  if (idx < last) {
    setTimeout(() => {
      currentIndex.value++;
    }, 120);
  }
}

function jumpTo(index) {
  if (index < 0 || index >= questions.value.length) return;
  currentIndex.value = index;
}

watch(
  isAllAnswered,
  (val) => {
    emit("status", { isAllAnswered: val });
  },
  { immediate: true }
);

// function emitStatus(val) {
//   // helper só para manter legibilidade
//   // sem depender de variável externa
//   const emit = defineEmits(["request-submit", "status"]);
//   emit("status", { isAllAnswered: val });
// }
</script>
